import { HttpErrorResponse } from '@angular/common/http';
import { ERROR_MESSAGES } from '../constants/validation-messages';

export function handleHttpError(error: any): string {
  if (!error) {
    return ERROR_MESSAGES.GENERIC;
  }

  // Se for HttpErrorResponse
  if (error instanceof HttpErrorResponse) {
    switch (error.status) {
      case 0:
        return ERROR_MESSAGES.NETWORK_ERROR;
      
      case 400:
        // Tenta pegar mensagem específica da API
        return error.error?.message || 
               error.error?.error || 
               'Dados inválidos. Por favor, verifique as informações fornecidas.';
      
      case 401:
        return ERROR_MESSAGES.UNAUTHORIZED;
      
      case 403:
        return ERROR_MESSAGES.FORBIDDEN;
      
      case 404:
        return ERROR_MESSAGES.NOT_FOUND;
      
      case 500:
      case 502:
      case 503:
        return ERROR_MESSAGES.SERVER_ERROR;
      
      default:
        return error.error?.message || 
               error.message || 
               ERROR_MESSAGES.GENERIC;
    }
  }

  // Se tiver mensagem de erro
  if (error.message) {
    return error.message;
  }

  // Fallback genérico
  return ERROR_MESSAGES.GENERIC;
}

